import {MatchEvent} from '../resources/MatchEvent';
import {DomainEvent} from './DomainEvent';

export class MatchEventRedCard extends DomainEvent<MatchEvent> {}
